import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'

import Twitter from 'assets/icons/twitter-lc.svg'
// import LinkedIn from 'assets/icons/linkedin-lc.svg'
import FB from 'assets/icons/facebook-lc.svg'
import IG from 'assets/icons/instagram-lc.svg'

// import Share from 'assets/icons/share_blk.svg'

import Grid from '@material-ui/core/Grid'
import clsx from 'clsx'

const useStyles = makeStyles({
  image: ({ size }) => {
    const mapSizeToDimensions = {
      small: {
        width: 18,
        height: 18,
      },
      normal: {
        width: 24,
        height: 24,
      },
      large: {
        width: 32,
        height: 32,
      },
    }

    return mapSizeToDimensions[size]
  },
  shareIcon: {
    opacity: 0.8,
  },
  iconButton: {
    backgroundColor: '#fff',
  },
})

const SocialMediaBar = (props) => {
  const [open, setOpen] = useState(false)
  const {
    url,
    title,
    theme,
    hashtags,
    description,
    orientation,
    follow,
    size,
    ContainerProps,
  } = props
  const classes = useStyles({ size })

  const encodedURL = encodeURIComponent(url)
  const joinedHashtags = hashtags.join(',')

  const handleCopyToClipboard = async (e) => {
    e.stopPropagation()

    try {
      await navigator.clipboard.writeText(url)
      setOpen(true)

      const id = setTimeout(() => {
        setOpen(false)
        clearTimeout(id)
      }, 1500)
    } catch (err) {
      console.log(err)
    }
  }

  const icons = [
    // 'linkedIn',
    'facebook',
    'twitter',
    'instagram',
  ]

  if (follow) icons.push('instagram')

  const mapIconToTheme = {
    twitter: {
      normal: Twitter,
      black: null,
      outlined: null,
      filled: null,
    },
    linkedIn: {
      normal: null,
      black: null,
      outlined: null,
      filled: null,
    },
    facebook: {
      normal: FB,
      black: null,
      outlined: null,
      filled: null,
    },
    instagram: {
      normal: IG,
      black: null,
      outlined: null,
      filled: null,
    },
  }

  const mapIconToShareLink = {
    twitter: `https://twitter.com/intent/tweet?text=${title}&url=${encodedURL}&hashtags=${joinedHashtags}`,
    // linkedIn: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedURL}`,
    facebook: `https://www.facebook.com/sharer.php?u=${encodedURL}`,
    instagram: '',
  }

  const mapIconToFollowLink = {
    // linkedIn: '',
    twitter: '',
    facebook: '',
    instagram: '',
  }

  const mapOrientationToDirection = {
    vertical: 'column',
    horizontal: 'row',
  }

  const trackClick = (e, { label }) => {
    e.stopPropagation()
    gtag(
      'event',
      follow ? 'follow' : 'share',
      {
        event_category: 'engagement',
        event_label: label,
      },
    )
  }

  return (
    <Grid container spacing={3} direction={mapOrientationToDirection[orientation]} {...ContainerProps}>
      {
        icons.map(x => (
          <Grid key={x} item>
            <a href={follow ? mapIconToFollowLink[x] : mapIconToShareLink[x]} target="_blank" rel="noopener noreferrer" aria-label={title}>
              <IconButton
                className={classes.iconButton}
                onClick={(e) => {
                  trackClick(e, { label: follow ? x : mapIconToShareLink[x] })
                }}
              >
                <img className={classes.image} src={mapIconToTheme[x][theme]} alt="Red Thread Venture" />
              </IconButton>
            </a>
          </Grid>
        ))
      }
      {/* {
        !follow && (
          <Tooltip
            PopperProps={{ disablePortal: true }}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title="Copied link!"
          >
            <IconButton onClick={handleCopyToClipboard}>
              <img className={clsx(classes.image, classes.shareIcon)} src={Share} alt="Share this URL" />
            </IconButton>
          </Tooltip>
        )
      } */}
    </Grid>
  )
}

SocialMediaBar.propTypes = {
  url: PropTypes.string,
  hashtags: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  orientation: PropTypes.oneOf([
    'vertical',
    'horizontal',
  ]),
  theme: PropTypes.oneOf([
    'normal',
    'black',
    'outlined',
    'filled',
  ]),
  size: PropTypes.oneOf([
    'small',
    'normal',
    'large',
  ]),
  follow: PropTypes.bool,
  ContainerProps: PropTypes.object,
}

SocialMediaBar.defaultProps = {
  url: window.location.href,
  hashtags: [],
  title: '',
  orientation: 'horizontal',
  theme: 'normal',
  size: 'normal',
  follow: false,
  ContainerProps: {},
}

export default SocialMediaBar
